const MUTATE_VISIBILITY = 'MUTATE_VISIBILITY';
const SET_MODAL_PARAMETERS = 'SET_MODAL_PARAMETERS';

export default {
	namespaced: true,
	state: {
		visible: false,
		params: {}
	},
	actions: {
		toggle({state, commit}) {
			commit(MUTATE_VISIBILITY, !state.visible);
			// https://jira.shiwaforce.com/browse/TARR2558-154 ...
			// document.body.classList.toggle('modal-open');
		},
		setModalParameters({commit}, {params}) {
			commit(SET_MODAL_PARAMETERS, {params});
		}
	},
	mutations: {
		[MUTATE_VISIBILITY](state, payload) {
			state.visible = payload;
		},
		[SET_MODAL_PARAMETERS](state, payload) {
			state.params = payload.params;
		}
	}
};



// WEBPACK FOOTER //
// ../source/common/modal/modal.vuex.js